import { Button } from '@/components/Elements';
import { ErrorScreen } from '@/pages/ErrorScreen';
import { useTranslation } from 'react-i18next';

export const ExpiredPasswordReset = () => {
  const { t } = useTranslation();
  const nextUrl = window.location.origin + '/password-reset';

  return (
    <ErrorScreen
      opts={{ statusCode: 404 }}
      error={{
        message: t(
          'パスワード再設定の有効期限が切れたため、このリンクは無効です。以下のボタンをクリックし、画面に表示される指示に従ってパスワード設定してください。'
        ),
      }}
      Button={
        <Button onClick={() => (window.location.href = nextUrl)}>
          {t('パスワードの再設定をやり直す')}
        </Button>
      }
    />
  );
};
